import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Form, InputGroup, Nav, Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { deleteOrderItem, downloadBulkOrderInvoice, downloadOrdersExcelSheet, getCompletedOrdersListing, getOrdersListing, getRejectedOrdersListing } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import orderexchange from '../../assets/images/order-exchange.png';
import orderreturn from '../../assets/images/order-return.png';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import Select from 'react-select'
import { useFormik } from 'formik'
import Offcanvas from 'react-bootstrap/Offcanvas';

import { useRecoilState } from 'recoil';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SelectionContext } from '../../Context/Store';
import toast from 'react-hot-toast';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { FaDownload, FaFile, FaJediOrder } from "react-icons/fa6";
import { getBrandListing } from "../../api/context/brand";
import BulkInvoiceModal from './BulkOrderInvoice';
import { getManufacturesListingPaginate } from '../../api/context/manufacturer';
import { FiDownload, FiFile, FiFilter, FiX } from 'react-icons/fi';
import OrderFilterModal from './helpers/OrderFilterModal';
import { orderListFilter, orderPaginationState } from '../../atoms/orderListFilter';

// Extend dayjs with the plugins
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);


const queueDatatableCustomStyles = {
  headRow: {
    style: {
      backgroundColor: '#f8fafc',
      borderBottom: '1px solid #e2e8f0',
      minHeight: '48px',
    },
  },
  headCells: {
    style: {
      display: 'flex',
      justifyContent: 'center',
      fontWeight: '600',
      fontSize: '9px',
      padding: '10px 6px',
      color: '#475569',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      backgroundColor: '#f8fafc',
    },
  },
  cells: {
    style: {
      display: 'flex',
      fontSize: '10px',
      fontWeight: '500',
      color: '#0f172a',
      padding: '10px 6px',
    },
  },
  rows: {
    style: {
      minHeight: '48px',
      borderBottom: '1px solid #eef2f7',
      transition: 'background 0.15s ease',
      '&:not(:last-of-type)': {
        borderBottom: '1px solid #eef2f7',
      },
      '&:hover': {
        backgroundColor: '#f8fafc !important',
        cursor: 'pointer',
      },
    },
  },
  pagination: {
    style: {
      borderTop: '1px solid #eef2f7',
      minHeight: '52px',
      fontSize: '12px',
      color: '#475569',
    },
  },
};


const Orders = () => {

  const navigate = useNavigate()

  const { ordersTrigger, setOrdersTrigger } = useContext(SelectionContext)



  const [orders, setOrders] = useState([]);
  // const [completedorders, setCompletedOrders] = useState([]);
  // const [rejectedorders, setRejectedOrders] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filterData, setFilterData] = useRecoilState(orderListFilter);
  const [pagination, setPagination] = useRecoilState(orderPaginationState);

  const { page, limit } = pagination;

  // const [totalActiveRows, setTotalActiveRows] = useState(0);
  // const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [limitactive, setLimitActive] = useState(10);
  const [pageactive, setPageActive] = useState(1);
  const [limitinactive, setLimitInactive] = useState(10);
  const [pageinactive, setPageInactive] = useState(1);
  const [initial, setInitial] = useState(false);

  const [showFilters, setShowFilters] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [modal, setModal] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [filter, setFilter] = useState("all");
  const [show, setShow] = useState(false);
  const [checkoutErrorShown, setCheckoutErrorShown] = useState(false);
  const [downloadOrdersExcel, setDownloadOrdersExcel] = useState(false);
  const [totalOrdesToDownload, setTotalOrdersToDownload] = useState([]);
  const [limitDownloadOrders, setLimitDownloadOrders] = useState(5);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const typingRef = useRef(null);

  const [brands, setBrands] = useState([]);
  const [pageBrands, setPageBrands] = useState(1);
  const [hasMoreBrands, setHasMoreBrands] = useState(true);
  const [brandSearch, setBrandSearch] = useState('');

  const [hasMore, setHasMore] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowFilters = () => setShowFilters(true);
  const handleCloseFilters = () => setShowFilters(false);

  const [bulkInvoiceModal, setBulkInvoiceModal] = useState(false);
  const [bulkVendors, setBulkVendors] = useState([]);
  const [bulkStartDate, setBulkStartDate] = useState(null);
  const [bulkEndDate, setBulkEndDate] = useState(null);
  const [downloadingBulkInvoice, setDownloadingBulkInvoice] = useState(false);
  const [manufacturers, setManufacturers] = useState([]);
  const [hasMoreManufacture, setHasMoreManufacture] = useState(true);



  const orderTypeOptions = [
    { value: null, label: 'NEW' },
    { value: 1, label: 'RETURN' },
    { value: 2, label: 'EXCHANGE' }
  ]
  const orderStatusOptions = [
    { value: 'INITIATED', label: 'INITIATED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
    { value: 'CONFIRMED', label: 'CONFIRMED' },
    { value: 'DELIVERED', label: 'DELIVERED' },
    { value: 'REJECTED', label: 'REJECTED' }
  ]

  const paymentModeOptions = [
    { value: "COD", label: 'COD' },
    { value: "ONLINE", label: 'ONLINE' },
  ]

  const paymentStatusOptions = [
    { value: "PENDING", label: 'PENDING' },
    { value: "DONE", label: 'DONE' },
  ]

  const statusChipStyle = (bg, color = '#fff') => ({
    display: 'inline-block',
    backgroundColor: bg,
    color,
    padding: '3px 8px',
    borderRadius: '4px',
    fontWeight: 600,
    fontSize: '10px',
    letterSpacing: '0.01em',
    whiteSpace: 'nowrap',
  });

  const columns = [
    {
      id: 'product',
      name: 'Product',
      cell: (row) => {
        const products = row?.orderProducts || [];
        const firstImg = products.find(p => p?.Product?.thumbnailImageUrl)?.Product?.thumbnailImageUrl;
        const extra = products.length > 1 ? products.length - 1 : 0;
        return (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            {firstImg ? (
              <img
                src={firstImg}
                alt="product"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 4,
                  objectFit: 'cover',
                  border: '1px solid #e2e8f0',
                  background: '#f8fafc',
                }}
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            ) : (
              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 4,
                  background: '#f1f5f9',
                  border: '1px solid #e2e8f0',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#94a3b8',
                  fontSize: 8,
                  fontWeight: 600,
                }}
              >
                N/A
              </div>
            )}
            {extra > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: -4,
                  right: -6,
                  minWidth: 14,
                  height: 14,
                  padding: '0 3px',
                  background: '#0f172a',
                  color: '#fff',
                  fontSize: 9,
                  fontWeight: 700,
                  borderRadius: 999,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  lineHeight: 1,
                }}
              >
                +{extra}
              </span>
            )}
          </div>
        );
      },
      grow: 0.4,
      minWidth: '70px',
      ignoreRowClick: false,
      style: { paddingLeft: '16px', justifyContent: 'flex-start' },
    },
    {
      id: 'orderId',
      name: 'Order Id',
      selector: (row) => row?.orderId,
      cell: (row) => (
        <Tooltip title={row?.orderId} disableInteractive placement="top">
          <div
            style={{
              backgroundColor: row?.isScheduled ? '#fef3c7' : '#f1f5f9',
              color: row?.isScheduled ? '#92400e' : '#0f172a',
              padding: '3px 8px',
              borderRadius: '4px',
              fontWeight: 600,
              fontSize: '10px',
              cursor: 'pointer',
              textAlign: 'center',
              border: row?.isScheduled ? '1px solid #fbbf24' : '1px solid transparent',
              maxWidth: '140px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/orderdetails/${row.id}`);
            }}
          >
            {row?.orderId}
          </div>
        </Tooltip>
      ),
      grow: 1.3,
      minWidth: '130px',
      center: true,
    },
    {
      name: 'Status',
      cell: (row) => {
        const status = row?.status;
        let bg = '#334155', color = '#fff';
        switch (status) {
          case 'CANCELLED': bg = '#dc2626'; color = '#fff'; break;
          case 'INITIATED': bg = '#facc15'; color = '#0f172a'; break;
          case 'CONFIRMED': bg = '#0e7490'; color = '#fff'; break;
          case 'DELIVERED': bg = '#10b981'; color = '#fff'; break;
          case 'REJECTED': bg = '#dc2626'; color = '#fff'; break;
          default: bg = '#6d28d9'; color = '#fff';
        }
        return status ? (
          <span style={statusChipStyle(bg, color)}>
            {status.toLowerCase().split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}
          </span>
        ) : <span style={{ color: '#94a3b8' }}>N/A</span>;
      },
      sortable: true,
      center: true,
      grow: 0.9,
      minWidth: '100px',
      selector: (row) => row.status,
    },
    {
      id: 'createdAt',
      name: 'Date',
      selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
      cell: (row) => (
        <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement="top">
          <div style={{ color: '#475569', fontSize: '10px', whiteSpace: 'nowrap' }}>
            {moment(row?.createdAt).format('DD/MM/YY, hh:mm a')}
          </div>
        </Tooltip>
      ),
      grow: 1.1,
      minWidth: '120px',
      center: true,
    },
    {
      id: 'orderType',
      name: 'Type',
      selector: (row) => row?.orderType,
      cell: (row) => {
        const t = row?.orderType;
        const label = t === 3 ? 'Delivered' : t === 2 ? 'Exchange' : t === 1 ? 'Return' : 'New';
        let bg = '#e0f2fe', color = '#0369a1';
        if (t === 1) { bg = '#fee2e2'; color = '#b91c1c'; }
        else if (t === 2) { bg = '#ede9fe'; color = '#6d28d9'; }
        else if (t === 3) { bg = '#dcfce7'; color = '#166534'; }
        return (
          <span style={{
            display: 'inline-block',
            backgroundColor: bg,
            color,
            padding: '3px 10px',
            borderRadius: '999px',
            fontSize: '10px',
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}>
            {label}
          </span>
        );
      },
      center: true,
      grow: 0.7,
      minWidth: '85px',
    },
    {
      id: 'isScheduled',
      name: 'Scheduled',
      selector: (row) => row?.isScheduled,
      cell: (row) => (
        row?.isScheduled ? (
          <span style={statusChipStyle('#dcfce7', '#166534')}>Scheduled</span>
        ) : (
          <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>
        )
      ),
      center: true,
      grow: 0.7,
      minWidth: '90px',
    },
    {
      id: 'amount',
      name: 'Amount',
      selector: (row) => userType === 'ADMIN' ? row?.amount : row?.billingAmount,
      cell: (row) => {
        const amt = userType === 'ADMIN' ? row?.amount : row?.billingAmount;
        return (
          <Tooltip title={amt} disableInteractive placement="top">
            <div style={{ fontWeight: 700, color: '#0f172a', fontSize: '11px' }}>
              ₹{amt}
            </div>
          </Tooltip>
        );
      },
      center: true,
      grow: 0.6,
      minWidth: '80px',
    },
    {
      name: 'Return Id',
      cell: (row) => {
        let returnIds = [];
        if (row.returnIdForVedor) {
          returnIds = typeof row.returnIdForVedor === 'string'
            ? row.returnIdForVedor.split(',').map(id => id.trim())
            : Array.isArray(row.returnIdForVedor) ? row.returnIdForVedor : [];
        }
        return (
          <div className="d-flex justify-content-center flex-wrap gap-1">
            {returnIds.length > 0 ? returnIds.map((id, index) => (
              <Tooltip key={`return-${id}-${index}`} title={`View Return Order: ${id}`} disableInteractive placement="top">
                <span
                  style={{
                    color: '#dc2626',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: '10px',
                  }}
                  onClick={(e) => { e.stopPropagation(); navigate(`/orderdetails/${id}`); }}
                >
                  {id}
                </span>
              </Tooltip>
            )) : <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>}
          </div>
        );
      },
      center: true,
      grow: 0.8,
      minWidth: '95px',
      ignoreRowClick: true,
    },
    {
      name: 'Exchange Id',
      cell: (row) => {
        let exchangeIds = [];
        if (row.exchangeIdForVedor) {
          exchangeIds = typeof row.exchangeIdForVedor === 'string'
            ? row.exchangeIdForVedor.split(',').map(id => id.trim())
            : Array.isArray(row.exchangeIdForVedor) ? row.exchangeIdForVedor : [];
        }
        return (
          <div className="d-flex justify-content-center flex-wrap gap-1">
            {exchangeIds.length > 0 ? exchangeIds.map((id, index) => (
              <Tooltip key={`exchange-${id}-${index}`} title={`View Exchange Order: ${id}`} disableInteractive placement="top">
                <span
                  style={{
                    color: '#0b6a93',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: '10px',
                  }}
                  onClick={(e) => { e.stopPropagation(); navigate(`/orderdetails/${id}`); }}
                >
                  {id}
                </span>
              </Tooltip>
            )) : <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>}
          </div>
        );
      },
      center: true,
      grow: 0.8,
      minWidth: '95px',
      ignoreRowClick: true,
    },
    {
      name: 'Payment Status',
      cell: (row) => {
        const status = row?.paymentStatus;
        if (!status) return <span style={{ color: '#94a3b8' }}>N/A</span>;
        const done = status === 'DONE';
        return (
          <span style={statusChipStyle(done ? '#dcfce7' : '#fef3c7', done ? '#166534' : '#92400e')}>
            {done ? 'Completed' : 'Pending'}
          </span>
        );
      },
      center: true,
      grow: 1,
      minWidth: '110px',
      sortable: true,
    },
  ];

  const conditionalRowStyles = [

    {
      when: row => row.returnIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
        '&:hover': {
          backgroundColor: 'rgba(238, 145, 155, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(0, 140, 255, 0.1)', // Very light blue
        '&:hover': {
          backgroundColor: 'rgba(0, 140, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.returnIdForVedor !== null && row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(180, 120, 255, 0.1)', // Light purple
        '&:hover': {
          backgroundColor: 'rgba(180, 120, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
  ];



  const getAppliedFiltersCount = () => {
    let count = 0;

    const countArray = (arr) => (Array.isArray(arr) ? arr.length : 0);

    if (filterData.orderStatus) count += 1;
    if (filterData.paymentMode) count += 1;
    if (filterData.paymentStatus) count += 1;
    if (filterData.selected_orderType || (filterData.orderType !== null && filterData.orderType !== "")) count += 1;

    count += countArray(filterData.brands);
    count += countArray(filterData.vendors);

    if (filterData.startDate || filterData.endDate) count += 1;

    return count;
  };


  const appliedFiltersCount = getAppliedFiltersCount();





  const searchFormik = useFormik({
    initialValues: {
      startDate: filterData.startDate || '',
      endDate: filterData.endDate || '',
      orderType: filterData.orderType || '',
      selected_orderType: filterData.selected_orderType || '',
      orderStatus: filterData.orderStatus || '',
      selected_orderStatus: filterData.selected_orderStatus || '',
      paymentMode: filterData.paymentMode || '',
      selected_paymentMode: filterData.selected_paymentMode || '',
      paymentStatus: filterData.paymentStatus || '',
      selected_paymentStatus: filterData.selected_paymentStatus || '',
      brands: filterData.brands || [],
      selected_brands: filterData.selected_brands || []
    },
    validate: async (values) => {
      // Add validation logic if needed
    },
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      setFilterData(values);
      setShow(false);
    },
    enableReinitialize: true,
  });

  const exportOrdersToExcel = async (filter) => {
    setDownloadOrdersExcel(true);

    try {
      // 🔹 Build same params as fetchOrdersData
      const params = filterData ? { ...filterData, page, limit, search: filterData.search || '' } : { page, limit, search: '' };

      if (filter === "completed") {
        params.status = "CONFIRMED";
      }
      if (filter === "rejected") {
        params.status = "REJECTED";
      }
      if (filter === "cancelled") {
        params.status = "CANCELLED";
      }

      // 🔹 Call backend
      const response = await downloadOrdersExcelSheet(params);

      if (response?.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `orders_export_${new Date().toISOString().split("T")[0]}.xlsx`
        ); // dynamic file name
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error("Error exporting orders to Excel:", error);
    } finally {
      setDownloadOrdersExcel(false);
    }
  };


  // const handleMenuScrollToBottomBrands = () => {
  //   if (!hasMoreBrands) return;
  //   const nextPage = pageBrands + 1;
  //   fetchBrands(brandSearch, nextPage).then(() => {
  //     setPageBrands(nextPage);
  //   });
  // };

  // const handleBrandInputChange = (newValue, { action }) => {
  //   if (action === 'input-change') {
  //     setPageBrands(1);
  //     setHasMoreBrands(true);
  //   }
  //   return newValue;
  // };

  const handleBulkInvoiceDownload = async () => {
    if (!bulkStartDate || !bulkEndDate) {
      toast.error("Please select date range");
      return;
    }

    if (userType == 'ADMIN' && !bulkVendors.length) {
      toast.error("Please select vendors");
      return;
    }

    try {
      setDownloadingBulkInvoice(true);

      const payload = {
        startDate: dayjs(bulkStartDate).format("YYYY-MM-DD"),
        endDate: dayjs(bulkEndDate).format("YYYY-MM-DD"),
      };

      // ✅ Only ADMIN sends vendorIds
      if (userType === 'ADMIN') {
        payload.vendorIds = bulkVendors.map(v => v.value);
      }

      const response = await downloadBulkOrderInvoice(payload);

      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `vendor_invoices_${payload.startDate}_${payload.endDate}.zip`
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      setBulkInvoiceModal(false);
    } catch (error) {
      console.error("Bulk invoice download failed:", error);
      toast.error("Failed to download invoices");
    } finally {
      setDownloadingBulkInvoice(false);
    }
  };


  const fetchManufacturers = (inputValue = "", currentPage = 1, limit = 100) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(() => {
        getManufacturesListingPaginate({
          page: currentPage,
          limit,
          search: inputValue
        })((response) => {
          if (response?.statusCode === 200) {
            const results = response.results.map(item => ({
              value: item.value,   // ✅ correct
              label: item.label,   // ✅ correct
            }));

            setManufacturers(results);
            setHasMoreManufacture(results.length > 0);
            resolve(results);
          } else {
            setManufacturers([]);
            setHasMoreManufacture(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };



  const fetchAllOrderData = async (filter) => {
    let limit = limitDownloadOrders;
    const params = filterData ? { ...filterData, page, limit, search: filterData.search || '' } : { page, limit, search: '' };

    if (filter === 'completed') {
      params.status = 'CONFIRMED';
    }

    if (filter === 'rejected') {
      params.status = 'REJECTED';
    }

    if (filter === 'cancelled') {
      params.status = 'CANCELLED';
    }

    delete params.orderStatus;
    delete params.selected_orderStatus;
    delete params.selected_paymentMode;
    delete params.selected_paymentStatus;
    delete params.selected_orderType;

    params.orderType = params.orderType ?? "";

    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        setTotalOrdersToDownload(response?.data?.orders);
        setLimitDownloadOrders(response?.data?.totalItems);
        setLoading(false);
      } else {
        setTotalOrdersToDownload([]);
        setLimitDownloadOrders(5);
        setLoading(false);
      }
    });

  }; let typingTimer;

  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      console.log("Brand API params:", { page: currentPage, pageSize: limit, search: inputValue });

      typingTimer = setTimeout(() => {
        getBrandListing({ page: currentPage, pageSize: limit, search: inputValue })(response => {
          console.log("Brand API response:", response);
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            if (currentPage === 1) {
              setBrands(results);
            } else {
              setBrands((prevBrands) => [...prevBrands, ...results]);
            }

            setHasMore(results.length > 0);
            resolve(results);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };


  // const loadOptionsBrands = (inputValue) => {
  //   return fetchBrands(inputValue, 1).then((options) => {
  //     console.log("Options loaded:", options);
  //     return options;
  //   });
  // };
  // const handleMenuScrollToBottom = () => {
  //   if (hasMore) {
  //     const nextPage = pageBrands + 1;   // ✅ use pageBrands, not pagebrands
  //     fetchBrands(searchFormik.values.selected_brands?.label || '', nextPage).then(() => {
  //       setPageBrands(nextPage);
  //     });
  //   }
  // };

  const fetchOrdersData = async (filter) => {


    const params = filterData
      ? {
        ...filterData,
        orderType: filterData.orderType,
        page,
        limit,
        search: filterData.search || ''
      }
      : {
        orderType: "",
        page,
        limit,
        search: ''
      };

    if (filter === 'completed') {
      params.status = 'CONFIRMED';
    }

    if (filter === 'rejected') {
      params.status = 'REJECTED';
    }

    if (filter === 'cancelled') {
      params.status = 'CANCELLED';
    }

    if (!params.status && params.orderStatus) {
      params.status = params.orderStatus;
    }


    delete params.orderStatus;
    delete params.selected_orderStatus;
    delete params.selected_paymentMode;
    delete params.selected_paymentStatus;
    delete params.selected_orderType;
    delete params.selected_brands;

    if (params.brands && params.brands.length > 0) {
      params.brandIds = params.brands;                 // array version
      params.brand_id = params.brands[0];              // single ID (just in case)
      params.brandsCSV = params.brands.join(",");      // CSV string version
    }

    console.log('Final API params:', params);

    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        setOrders(response?.data?.orders);
        setTotalRows(response?.data?.totalItems);
        setLoading(false);
      } else {
        setOrders([]);
        setLoading(false);
      }
    });
  };


  const handlePerRowsChange = (newPerPage) => {
    setPagination(prev => ({
      ...prev,
      limit: newPerPage,
      page: 1
    }));
  };

  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      page
    }));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  // const handleConfirm = (deletingId) => {
  //   setModal(!modal);
  //   setDeletingId(deletingId);
  // };

  const deleteOrder = (id) => {
    deleteOrderItem(id)((response) => {
      if (response?.request?.status == 200) {

        setModal(!modal);
      } else {
      }
    });
    // });
  };



  const applyFilters = (partial) => {
    const processed = {};

    Object.keys(partial).forEach(key => {
      if (Array.isArray(partial[key])) {
        processed[key] = partial[key].map(item =>
          typeof item === 'object' ? item.value : item
        );
      } else {
        processed[key] = partial[key];
      }
    });

    setFilterData(prev => ({
      ...prev,
      ...processed
    }));

    setPagination(prev => ({
      ...prev,
      page: 1
    }));
  };


  const onOrderTypeChange = (selectedOption) => {
    applyFilters({
      orderType: selectedOption ? selectedOption.value : "",
      selected_orderType: selectedOption || ""
    });
  }

  // FIXED: Corrected the typo here
  const onOrderStatusChange = (selectedOption) => {
    setFilter("all");
    applyFilters({
      orderStatus: selectedOption?.value || "",
      selected_orderStatus: selectedOption || ""
    });
  }

  const onpaymentModeChange = (selectedOption) => {
    applyFilters({
      paymentMode: selectedOption?.value || "",
      selected_paymentMode: selectedOption || ""
    });
  }

  const onpaymentStatusChange = (selectedOption) => {
    applyFilters({
      paymentStatus: selectedOption?.value || "",
      selected_paymentStatus: selectedOption || ""
    });
  }

  const onBrandChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      brands: selectedValues,
      selected_brands: selectedOptions || [],
    });
  }

  const handleReset = () => {
    searchFormik.resetForm({
      values: {
        startDate: "",
        endDate: '',
        orderType: "",
        selected_orderType: "",
        orderStatus: "",
        selected_orderStatus: "",
        paymentMode: "",
        selected_paymentMode: "",
        paymentStatus: "",
        selected_paymentStatus: "",
        brands: [],
        selected_brands: []
      }
    });
    setFilterData({
      search: "",
      startDate: "",
      endDate: '',
      orderType: "",
      selected_orderType: "",
      orderStatus: "",
      selected_orderStatus: "",
      paymentMode: "",
      selected_paymentMode: "",
      paymentStatus: "",
      selected_paymentStatus: "",
      brands: [],
      selected_brands: []
    });
    setShow(false);

  };


  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (isFilterApplied) {
      searchFormik.handleSubmit(e);
    } else {
      handleReset();
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchOrdersData(filter);
    setIsInitialRender(false);
  }, [filter, filterData, pagination]);

  useEffect(() => {
    const delay = setTimeout(() => {
      setPagination(prev => ({ ...prev, page: 1 }));
    }, 400);

    return () => clearTimeout(delay);
  }, [filterData.search]);


  useEffect(() => {
    if (isInitialRender) return;
    setLoading(true);
    fetchAllOrderData(filter)
  }, [filter, filterData, pagination]);

  useEffect(() => {
    fetchManufacturers("", 1, 100);
  }, []);


  useEffect(() => {
    if (ordersTrigger) {
      fetchOrdersData(filter);
      setOrdersTrigger(false);
    }
  }, [ordersTrigger]);



  useEffect(() => {
    getBrandListing({ page: 1, pageSize: 100, search: "" })((response) => {
      if (response?.statusCode === 200) {
        setBrands(
          (response?.data || []).map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      } else {
        setBrands([]);
      }
    });
  }, []);

  const isFilterApplied = !!(
    filterData.startDate ||
    filterData.endDate ||
    filterData.selected_orderType ||
    filterData.orderType ||
    filterData.orderStatus ||
    filterData.paymentMode ||
    filterData.paymentStatus ||
    (filterData.brands && filterData.brands.length > 0)
  );

  const userType = JSON.parse(localStorage.getItem('user'))?.userType;

  const clearAllFilters = () => {
    setFilterData({
      search: "",
      startDate: "",
      endDate: "",
      orderType: "",
      selected_orderType: "",
      orderStatus: "",
      selected_orderStatus: "",
      paymentMode: "",
      selected_paymentMode: "",
      paymentStatus: "",
      selected_paymentStatus: "",
      brands: [],
      selected_brands: [],
      vendors: [],
    });
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const orderStatusChip = (status) => {
    if (!status) return null;
    // Match the desktop table Status column exactly
    let bg = '#334155', color = '#fff';
    switch (status) {
      case 'CANCELLED': bg = '#dc2626'; color = '#fff'; break;
      case 'INITIATED': bg = '#facc15'; color = '#0f172a'; break;
      case 'CONFIRMED': bg = '#0e7490'; color = '#fff'; break;
      case 'DELIVERED': bg = '#10b981'; color = '#fff'; break;
      case 'REJECTED': bg = '#dc2626'; color = '#fff'; break;
      default: bg = '#6d28d9'; color = '#fff';
    }
    return { bg, color, label: status.toLowerCase().split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') };
  };

  return (
    <div className="orders-page">
      <style>{`
        .orders-page h3 { font-size: 18px !important; }
        .orders-page h4 { font-size: 16px !important; }
        .orders-page h5 { font-size: 14px !important; }
        .orders-page h6 { font-size: 12px !important; }
        .orders-page p { font-size: 12px; }
        .orders-page .small, .orders-page small { font-size: 11px !important; }
        .orders-page .badge { font-size: 10px !important; padding: 3px 7px !important; }
        .orders-page .btn { font-size: 12px; }

        /* Compact action buttons */
        .orders-page .ord-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 6px 18px !important;
          border-radius: 4px !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          height: 34px;
          white-space: nowrap;
          transition: all 0.15s ease;
          border: 1px solid #e2e8f0;
          background: #fff;
          color: #475569;
          cursor: pointer;
          position: relative;
        }
        .orders-page .ord-btn:hover {
          border-color: #008695;
          color: #008695;
          background: rgba(0,134,149,0.06);
        }
        .orders-page .ord-btn-primary {
          background: #008695 !important;
          border-color: #008695 !important;
          color: #fff !important;
        }
        .orders-page .ord-btn-primary:hover {
          background: #006672 !important;
          border-color: #006672 !important;
          color: #fff !important;
        }
        .orders-page .ord-btn svg { width: 14px; height: 14px; }

        /* Search input */
        .orders-page .ord-search-input {
          border: 1px solid #e2e8f0 !important;
          border-radius: 4px !important;
          padding: 6px 12px !important;
          font-size: 12px !important;
          height: 34px !important;
          background: #fff !important;
          color: #0f172a !important;
        }
        .orders-page .ord-search-input:focus {
          border-color: #008695 !important;
          box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
          outline: none;
        }

        /* Filter count badge */
        .orders-page .ord-filter-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 16px;
          height: 16px;
          padding: 0 4px;
          font-size: 10px;
          font-weight: 700;
          color: #fff;
          background: #008695;
          border-radius: 999px;
          margin-left: 2px;
        }

        /* DataTable container */
        .orders-page .products-and-options .MuiPaper-root {
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          overflow: hidden;
          box-shadow: none !important;
        }

        /* Page-content: zero horizontal + top padding */
        body:has(.orders-page) .page-content {
          padding: 0 0 24px 0 !important;
        }
        body:has(.orders-page) #layout-wrapper.no-topbar .page-content {
          padding: 0 0 24px 0 !important;
        }

        /* Sticky header — zero horizontal padding, sits flush */
        .orders-page .page-header-sticky {
          padding: 12px 0 !important;
          margin: 0 0 12px 0 !important;
          top: 0 !important;
        }
        .orders-page .page-header-sticky > .d-flex { margin-bottom: 0 !important; }
        @media (max-width: 991px) {
          .orders-page .page-header-sticky {
            padding: 10px 0 !important;
            margin: 0 0 10px 0 !important;
          }
        }
        @media (max-width: 575px) {
          .orders-page .page-header-sticky {
            padding: 10px 0 !important;
            margin: 0 0 8px 0 !important;
          }
        }

        .orders-page .ord-search-row { margin: 12px 0; padding: 0; }
        .orders-page .products-and-options { padding: 0; }

        /* Mobile card grid — hidden on desktop */
        .orders-page .orders-mobile-list { display: none; }
        .orders-page .orders-mobile-pagination { display: none; }

        /* Responsive */
        @media (max-width: 767.98px) {
          .orders-page .page-header-sticky > .d-flex {
            flex-wrap: nowrap !important;
            gap: 6px !important;
          }
          .orders-page .page-header-sticky > .d-flex > h3 {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .orders-page .ord-header-actions {
            gap: 6px !important;
            flex-wrap: nowrap !important;
            flex-shrink: 0;
          }
          .orders-page .ord-header-actions .ord-btn {
            width: 32px;
            height: 32px;
            padding: 0 !important;
          }
          .orders-page .ord-header-actions .ord-btn-label { display: none; }

          .orders-page .ord-search-row { flex-wrap: nowrap !important; gap: 8px !important; }
          .orders-page .ord-search-row > div:first-child { flex: 1 1 auto !important; min-width: 0 !important; }
          .orders-page .ord-filter-actions { flex-shrink: 0; gap: 6px !important; }
          .orders-page .ord-filter-btn,
          .orders-page .ord-clear-btn {
            width: 34px;
            padding: 0 !important;
          }
          .orders-page .ord-filter-btn .ord-btn-label,
          .orders-page .ord-clear-btn .ord-btn-label { display: none; }
          .orders-page .ord-filter-btn .ord-filter-count {
            position: absolute;
            top: -4px; right: -4px;
            min-width: 14px; height: 14px;
            padding: 0 3px;
            font-size: 9px;
            margin-left: 0;
          }

          /* Swap table for mobile card list */
          .orders-page .products-and-options { display: none !important; }
          .orders-page .orders-mobile-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 8px 0 calc(56px + env(safe-area-inset-bottom, 0px));
          }

          /* Fixed bottom pagination bar */
          .orders-page .orders-mobile-pagination {
            display: flex !important;
            position: fixed;
            left: 0; right: 0; bottom: 0;
            padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
            background: #fff;
            border-top: 1px solid #e2e8f0;
            box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
            z-index: 1049;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
          }
          .orders-page .omp-btn {
            width: 40px; height: 36px;
            border-radius: 6px;
            border: 1px solid #e2e8f0;
            background: #fff;
            color: #0f172a;
            font-size: 16px;
            font-weight: 700;
            cursor: pointer;
            display: inline-flex; align-items: center; justify-content: center;
            transition: all 0.15s ease;
          }
          .orders-page .omp-btn:hover:not(:disabled) {
            border-color: #008695;
            color: #008695;
            background: rgba(0,134,149,0.06);
          }
          .orders-page .omp-btn:disabled {
            opacity: 0.35;
            cursor: not-allowed;
          }
          .orders-page .omp-info {
            font-size: 11px;
            color: #475569;
            display: inline-flex;
            align-items: baseline;
            gap: 4px;
            flex: 1;
            justify-content: center;
            text-align: center;
          }
          .orders-page .omp-info strong { color: #008695; font-weight: 700; }
          .orders-page .omp-total { color: #94a3b8; font-size: 10px; }
        }

        /* Mobile order card */
        .orders-page .order-card {
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 12px;
          cursor: pointer;
          transition: transform 0.12s ease, border-color 0.15s ease;
        }
        .orders-page .order-card:active { transform: scale(0.99); border-color: #008695; }
        .orders-page .order-card-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 8px;
          margin-bottom: 8px;
        }
        .orders-page .order-card-id {
          font-size: 10px;
          font-weight: 700;
          color: #0f172a;
        }
        .orders-page .order-card-date {
          font-size: 9px;
          color: #64748b;
          margin-top: 1px;
        }
        .orders-page .order-card-chip {
          font-size: 10px !important;
          font-weight: 600;
          padding: 3px 8px !important;
          border-radius: 4px;
          white-space: nowrap;
          letter-spacing: 0.01em;
        }
        .orders-page .order-card-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 6px;
          font-size: 10px;
        }
        .orders-page .order-card-row + .order-card-row { margin-top: 4px; }
        .orders-page .order-card-label { color: #64748b; font-size: 10px; }
        .orders-page .order-card-value { color: #0f172a; font-weight: 600; font-size: 10px; }
        .orders-page .order-card-amount { color: #008695; font-weight: 700; font-size: 11px; }
        .orders-page .order-card-price {
          color: #008695;
          font-weight: 800;
          font-size: 15px;
          letter-spacing: -0.02em;
          line-height: 1.1;
          margin: 2px 0 4px;
        }
        .orders-page .order-card-pay {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 2px;
          border-radius: 999px;
          background: #f8fafc;
          border: 1px solid #eef2f7;
          width: fit-content;
        }
        .orders-page .order-card-pay-mode,
        .orders-page .order-card-pay-status {
          font-size: 9px;
          font-weight: 700;
          padding: 3px 8px;
          border-radius: 999px;
          white-space: nowrap;
          letter-spacing: 0.02em;
          text-transform: uppercase;
        }
        .orders-page .order-card-pay-status {
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .orders-page .order-card-pay-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          display: inline-block;
          box-shadow: 0 0 0 2px rgba(255,255,255,0.5);
        }
        .orders-page .order-card-type {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 9px;
          color: #475569;
        }
        .orders-page .order-card-type img { width: 10px; height: 10px; object-fit: contain; }
      `}</style>

      <div className="page-header-sticky">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
          <div className="d-flex align-items-center">
            <h3 className="mb-0 fw-bolder">Orders</h3>
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap ord-header-actions">
            <div className="ord-btn" onClick={() => setBulkInvoiceModal(true)}>
              <FiFile />
              <span className="ord-btn-label">Download Bulk Invoice</span>
            </div>

            {userType !== 'customerSupport' && (
              <div className="ord-btn ord-btn-primary" onClick={() => exportOrdersToExcel()}>
                {downloadOrdersExcel ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span className="ord-btn-label">Exporting...</span>
                  </>
                ) : (
                  <>
                    <FiDownload />
                    <span className="ord-btn-label">Export orders</span>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="ord-search-row d-flex justify-content-between align-items-center gap-2 flex-wrap">
        <div style={{ flex: 2, minWidth: '220px' }}>
          <Form.Control
            type="text"
            placeholder="Search for orders..."
            className="ord-search-input"
            value={filterData.search || ""}
            onChange={(e) => setFilterData(prev => ({ ...prev, search: e.target.value }))}
          />
        </div>

        <div className="d-flex align-items-center gap-2 ord-filter-actions">
          <button
            type="button"
            className="ord-btn ord-filter-btn"
            onClick={() => setShowFilterModal(true)}
          >
            <FiFilter />
            <span className="ord-btn-label">Filters</span>
            {appliedFiltersCount > 0 && (
              <span className="ord-filter-count">{appliedFiltersCount}</span>
            )}
          </button>

          <button
            type="button"
            className="ord-btn ord-clear-btn"
            onClick={clearAllFilters}
          >
            <FiX />
            <span className="ord-btn-label">Clear</span>
          </button>
        </div>
      </div>

      <div className="col-12">
        <Box className="products-and-options">
          <Paper square className="shadow-none border border-blue-grey-200">
            <DataTable
              columns={columns}
              conditionalRowStyles={conditionalRowStyles}
              data={orders}
              progressPending={loading}
              progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationPerPage={limit}
              onRowClicked={(row) => navigate('/orderdetails/' + row?.id)}
              onChangeRowsPerPage={handlePerRowsChange}
              pointerOnHover
              highlightOnHover
              paginationRowsPerPageOptions={[10, 50, 100, 150]}
              onChangePage={handlePageChange}
              currentPage={page}
              customStyles={queueDatatableCustomStyles}
            />
          </Paper>
        </Box>

        <div className="orders-mobile-list">
          {loading ? (
            <div style={{ height: '40vh' }}><Loader /></div>
          ) : orders && orders.length > 0 ? (
            orders.map((row) => {
              const chip = orderStatusChip(row?.status);
              const t = row?.orderType;
              const typeLabel = t === 3 ? 'Delivered' : t === 2 ? 'Exchange' : t === 1 ? 'Return' : 'New';
              let typeBg = '#e0f2fe', typeColor = '#0369a1';
              if (t === 1) { typeBg = '#fee2e2'; typeColor = '#b91c1c'; }
              else if (t === 2) { typeBg = '#ede9fe'; typeColor = '#6d28d9'; }
              else if (t === 3) { typeBg = '#dcfce7'; typeColor = '#166534'; }
              const amt = userType === 'ADMIN' ? row?.amount : row?.billingAmount;
              const done = row?.paymentStatus === 'DONE';
              const products = row?.orderProducts || [];
              const firstImg = products.find(p => p?.Product?.thumbnailImageUrl)?.Product?.thumbnailImageUrl;
              const extra = products.length > 1 ? products.length - 1 : 0;
              return (
                <div
                  key={row.id}
                  className="order-card"
                  onClick={() => navigate('/orderdetails/' + row?.id)}
                  style={{ display: 'flex', gap: 12, alignItems: 'stretch' }}
                >
                  {/* Image on the left */}
                  <div style={{ position: 'relative', flexShrink: 0 }}>
                    {/* Type label overlay on top of the image */}
                    <span
                      style={{
                        position: 'absolute',
                        top: 6,
                        left: 6,
                        zIndex: 2,
                        display: 'inline-block',
                        backgroundColor: typeBg,
                        color: typeColor,
                        padding: '2px 6px',
                        borderRadius: '999px',
                        fontSize: '8px',
                        fontWeight: 700,
                        lineHeight: 1.2,
                        boxShadow: '0 1px 3px rgba(15,23,42,0.15)',
                      }}
                    >
                      {typeLabel}
                    </span>
                    {firstImg ? (
                      <img
                        src={firstImg}
                        alt="product"
                        style={{
                          width: 96,
                          height: 120,
                          borderRadius: 6,
                          objectFit: 'cover',
                          border: '1px solid #e2e8f0',
                          display: 'block',
                        }}
                        onError={(e) => { e.currentTarget.style.display = 'none'; }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 96,
                          height: 120,
                          borderRadius: 6,
                          background: '#f1f5f9',
                          border: '1px solid #e2e8f0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#94a3b8',
                          fontSize: 9,
                          fontWeight: 600,
                        }}
                      >
                        N/A
                      </div>
                    )}
                    {extra > 0 && (
                      <span
                        style={{
                          position: 'absolute',
                          top: -4,
                          right: -6,
                          minWidth: 18,
                          height: 18,
                          padding: '0 5px',
                          background: '#0f172a',
                          color: '#fff',
                          fontSize: 10,
                          fontWeight: 700,
                          borderRadius: 999,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          lineHeight: 1,
                        }}
                      >
                        +{extra}
                      </span>
                    )}
                  </div>

                  {/* All labels / status stacked on the right */}
                  <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {/* Top row: Order Id + Status chip */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <div className="order-card-id">#{row?.orderId}</div>
                        <div className="order-card-date">
                          {moment(row?.createdAt).format('DD MMM YY, hh:mm a')}
                        </div>
                      </div>
                      {chip && (
                        <span className="order-card-chip" style={{ background: chip.bg, color: chip.color, flexShrink: 0 }}>
                          {chip.label}
                        </span>
                      )}
                    </div>

                    {/* Price — prominent, right under the id+date row */}
                    <div className="order-card-price">₹{amt}</div>

                    {/* Payment method + status — split pill */}
                    {(() => {
                      const mode = (row?.paymentMode || '').toUpperCase();
                      const isCOD = mode === 'COD';
                      const modeLabel = isCOD ? 'COD' : mode ? 'Online' : '—';
                      // Method: neutral slate for both — text-only differentiation
                      const modeBg = '#f1f5f9';
                      const modeColor = '#475569';
                      // Status: standard muted green (Paid) / amber (Pending)
                      const statusBg = done ? '#f0fdf4' : '#fffbeb';
                      const statusColor = done ? '#15803d' : '#b45309';
                      const statusDot = done ? '#16a34a' : '#d97706';
                      const statusLabel = done ? 'Paid' : 'Pending';
                      return (
                        <div className="order-card-pay">
                          <span
                            className="order-card-pay-mode"
                            style={{ background: modeBg, color: modeColor }}
                          >
                            {modeLabel}
                          </span>
                          <span
                            className="order-card-pay-status"
                            style={{ background: statusBg, color: statusColor }}
                          >
                            <span className="order-card-pay-dot" style={{ background: statusDot }} />
                            {statusLabel}
                          </span>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: 'center', padding: '32px 12px', color: '#94a3b8', fontSize: 12 }}>
              No orders found
            </div>
          )}
        </div>
      </div>

      {/* Mobile-only fixed pagination bar */}
      {(() => {
        const totalPages = Math.max(1, Math.ceil((totalRows || 0) / (limit || 1)));
        const canPrev = page > 1;
        const canNext = page < totalPages;
        return (
          <div className="orders-mobile-pagination">
            <button
              type="button"
              className="omp-btn"
              onClick={() => canPrev && handlePageChange(page - 1)}
              disabled={!canPrev}
              aria-label="Previous page"
            >
              ←
            </button>
            <span className="omp-info">
              Page <strong>{page}</strong> of <strong>{totalPages}</strong>
              <span className="omp-total">· {totalRows || 0} orders</span>
            </span>
            <button
              type="button"
              className="omp-btn"
              onClick={() => canNext && handlePageChange(page + 1)}
              disabled={!canNext}
              aria-label="Next page"
            >
              →
            </button>
          </div>
        );
      })()}
      <CustomisedModal
        isOpen={modal}
        customClass={"policy_modal"}
        toggle={toggleModal}
      >
        <h5>Are you sure you want to remove this item?</h5>
        <div className="policy_Agree">
          <Button
            onClick={() => {
              setModal(!modal);
            }}
            size="lg"
            className="btn_cancel"
          >
            Cancel
          </Button>
          <Button
            size="lg"
            className="btn"
            onClick={() => deleteOrder(deletingId)}
          >
            Delete
          </Button>
        </div>
      </CustomisedModal>

      <BulkInvoiceModal
        open={bulkInvoiceModal}
        onClose={() => setBulkInvoiceModal(false)}
        vendors={manufacturers}          // vendor list
        selectedVendors={bulkVendors}
        setSelectedVendors={setBulkVendors}
        startDate={bulkStartDate}
        setStartDate={setBulkStartDate}
        endDate={bulkEndDate}
        setEndDate={setBulkEndDate}
        loading={downloadingBulkInvoice}
        onDownload={handleBulkInvoiceDownload}
      />

      <OrderFilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        onApplyFilters={applyFilters}
        searchFormik={searchFormik}
        filterData={filterData}
        userType={userType}
      />

    </div>
  );
}


export default Orders
